export default __webpack_public_path__ + "static/media/330_store03-es-web.1545caec.png";